'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_LDMLLocale(language, territory, variant, script) {
  this.mc = null;
  this.me = null;
  this.mf = null;
  this.md = null;
  this.mc = language;
  this.me = territory;
  this.mf = variant;
  this.md = script;
}
export { $c_Llocales_cldr_LDMLLocale as $c_Llocales_cldr_LDMLLocale };
$p = $c_Llocales_cldr_LDMLLocale.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_LDMLLocale;
/** @constructor */
function $h_Llocales_cldr_LDMLLocale() {
}
export { $h_Llocales_cldr_LDMLLocale as $h_Llocales_cldr_LDMLLocale };
$h_Llocales_cldr_LDMLLocale.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_LDMLLocale)) {
    if ((this.mc === x$0.mc)) {
      var x = this.me;
      var x$2 = x$0.me;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.mf;
      var x$4 = x$0.mf;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.md;
      var x$6 = x$0.md;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "LDMLLocale";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.mc;
      break;
    }
    case 1: {
      return this.me;
      break;
    }
    case 2: {
      return this.mf;
      break;
    }
    case 3: {
      return this.md;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e0)));
}
export { $isArrayOf_Llocales_cldr_LDMLLocale as $isArrayOf_Llocales_cldr_LDMLLocale };
var $d_Llocales_cldr_LDMLLocale = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_LDMLLocale, "locales.cldr.LDMLLocale", ({
  e0: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_LDMLLocale as $d_Llocales_cldr_LDMLLocale };
